/**
 * Extract a human-readable message from an axios error.
 *
 * FastAPI validation errors return `detail` as an array of
 * { type, loc, msg, input } objects — rendering that array directly as a React
 * child throws "Objects are not valid as a React child". This normalises any
 * shape (string, array, object) into a safe string.
 */
export function apiErrorMessage(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d)))
      .join('; ') || fallback;
  }
  if (detail && typeof detail === 'object') return detail.msg || JSON.stringify(detail);
  return err?.message || fallback;
}
